// extracted by mini-css-extract-plugin
export default {"logo":"louve_logo__3pvFu","container":"louve_container__Ngc57","isLoading":"louve_isLoading__3BRK5","withStroke":"louve_withStroke__xnteo","louveStroke":"louve_louveStroke__8uYC7"};